import { useEffect, useState } from "react";
import { ThemeProvider } from "next-themes";
import { AnimatePresence } from "framer-motion";
import "@/App.css";

import Loader from "@/components/Loader";
import Navbar from "@/components/Navbar";
import CustomCursor from "@/components/CustomCursor";
import GrainOverlay from "@/components/GrainOverlay";
import SmoothScroll from "@/components/SmoothScroll";

import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Capabilities from "@/sections/Capabilities";
import Philosophy from "@/sections/Philosophy";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

function App() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setLoaded(true), 1600);
        return () => clearTimeout(t);
    }, []);

    return (
        <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false} themes={["light", "dark"]}>
            <div className="App bg-sb text-sb cursor-hidden" data-testid="sysbrains-app">
                <AnimatePresence>{!loaded && <Loader key="sb-loader" />}</AnimatePresence>
                <CustomCursor />
                <GrainOverlay />
                <SmoothScroll>
                    <Navbar />
                    <main>
                        <Hero />
                        <About />
                        <Capabilities />
                        <Philosophy />
                        <Contact />
                    </main>
                    <Footer />
                </SmoothScroll>
            </div>
        </ThemeProvider>
    );
}

export default App;
